import React, { useState, useContext } from 'react'
import ScheduleEmailModal from './schedule-email-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'
import { useScheduledEmails } from 'api/hooks/use-scheduled-emails'
import UserContext from 'context/user-context'

// `hideTrigger` + `show`/`setShow` let a menu item elsewhere open the modal, as the report-builder's
// ScheduleEmailButton does.
function ScheduleEmailButton({
  dashboard,
  iconOnly = false,
  hideTrigger = false,
  show: controlledShow,
  setShow: controlledSetShow
}) {
  const [internalShow, setInternalShow] = useState(false)
  const show = controlledShow ?? internalShow
  const setShow = controlledSetShow || setInternalShow
  const { data: emails } = useScheduledEmails({
    dashboardId: dashboard?.id,
    params: {},
    options: { enabled: !!dashboard?.id }
  })
  const user = useContext(UserContext)

  const isOwner = user.id === dashboard?.user_id
  const isDashboardEditor = dashboard?.shared_users?.find((du) => du.user_id === user.id)?.is_editor ?? false
  const isFolderEditor = dashboard?.is_folder_editor
  const canEdit = isOwner || isDashboardEditor || isFolderEditor

  if (!canEdit) {
    return ''
  }

  return (
    <>
      {hideTrigger ? null : iconOnly ? (
        emails?.data?.length > 0 ? (
          <span
            className="text-muted small"
            style={{ cursor: 'pointer' }}
            onClick={() => setShow(true)}
          >
            <FontAwesomeIcon icon={faEnvelope} /> {emails?.data?.length}
          </span>
        ) : null
      ) : (
        <Button variant="light" className="bg-light text-dark" size="sm" onClick={() => setShow(true)}>
          <span>
            <FontAwesomeIcon icon={faEnvelope} /> {emails?.data?.length}
          </span>{' '}
        </Button>
      )}
      {show && (
        <ScheduleEmailModal
          show={show}
          handleClose={() => setShow(false)}
          dashboard={dashboard}
          emails={emails}
        />
      )}
    </>
  )
}

export default ScheduleEmailButton
